<template>
  <div
    v-show="navigationShouldDisplay"
    class="navigation-wrapper">
    <div class="navigation">
      <div class="logo-wrapper">
        <router-link
          :to="{name: 'Index'}"
          class="logo">
          爱车的诺诺
        </router-link>
      </div>

      <ul class="navi-anchors-wrapper">
        <li class="navi-anchor-wrapper">
          <router-link
            :to="{name: 'Index'}"
            :class="[
              'navi-anchor',
              isStandard ? 'active' : '',
            ]">
            标准自营车
          </router-link>
        </li>

        <li class="navi-anchor-wrapper">
          <router-link
            :to="{name: 'Wholesale2List'}"
            :class="[
              'navi-anchor',
              isWholesale2 ? 'active' : '',
            ]">
            批发区
          </router-link>
        </li>

        <li class="navi-anchor-wrapper">
          <router-link
            :to="{name: 'Recycle'}"
            :class="[
              'navi-anchor',
              $route.path === '/recycle' ? 'active' : ''
            ]">
            卖车
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import {useRoute} from 'vue-router'

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Navigation',

  data: () => ({}),

  computed: {
    // navigationShouldDisplay
    // - 判断当前 url 是否在 ibs 项目（ibs 引用 zyc 项目的 EchartsReport）
    //   如果是, 则不显示 navigation 导航组件
    navigationShouldDisplay () {

      var url = (window.location != window.parent.location)
        ? document.referrer
        : document.location.href

      if (
        url === 'http://ibs.nuo.com/'
        || url === 'https://test-ibs.ichenuonuo.com/'
        || url === 'https://ibs.nuonuo.com.cn/'
      ){
        return false
      }

      const route = useRoute()

      return route.name !== 'pictures'
    },

    // isStandard
    // - Date: 2023.06.12
    // - Check if the current route is standard related
    isStandard () {
      const route = useRoute()

      if (this.$route.name && this.$route.name.toLowerCase() === 'index') {
        return true
      }
      else if (/^\/car/ig.test(route.path)) {
        return true
      }
      else {
        return false
      }
    },

    // isWholesale2
    // - Date: 2023.09.12
    //   - Check if the current route is wholesale2 related
    // - Date: 2023.09.21
    //   - Since the car id is no longer available as Number and is replaced
    //     with an encrypted string (e.g. `Wmd0Zmp2U2RmVVk9`),
    //     the function checks the URL pattern to see if it starts with `/w`
    //     or `/wholesales`.
    isWholesale2 () {
      const route = useRoute()

      return /^\/w|\/wholesales/ig.test(route.path)
    },
  },
}
</script>

<style lang="scss" scoped>
.navigation-wrapper {
  z-index: 100;
  position: fixed;
  width: 100%;
  height: 44px;
  box-shadow:  0px 0px 2px 0px rgb(0,0,0, .3);
  background: #ffffff;
  // background: rgba(255, 255, 255, 0.7);
  // backdrop-filter: blur(8px);

  .navigation {
    width: 100%;
  }
}

.navigation {
  height: 100%;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
}

.logo-wrapper {
  display: none;
  padding: 0 10px;
  box-sizing: border-box;
  height: 100%;
}

.logo {
  background: transparent url('https://static.nuonuo.com.cn/zycmp/logo.png') center center no-repeat;
  text-indent: -9999px;
  background-size: 120%;
  white-space: nowrap;
  display: inline-block;
  width: 90px;
  height: 100%;
}


.navi-anchor-wrapper > li {
  flex: 1;
}

@media (min-width: 760px) {
  .logo-wrapper {
    display: block;
  }

  .logo {
    background: transparent url('https://static.nuonuo.com.cn/zycmp/logo.png') center center no-repeat;
    text-indent: -9999px;
    background-size: 90% auto;
    white-space: nowrap;
    display: inline-block;
    width: 180px;
    height: 100%;
  }
 }

.navi-anchors-wrapper {
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  height: 100%;
  margin-left: unset;

  & > li {
    flex: 1;
    display: flex;
    justify-content: center;
  }

  & > li > a {
    margin: auto;
  }
}

.navi-anchor-wrapper {
  height: 100%;
  padding: 6px 0;
  box-sizing: border-box;
  display: flex;
  justify-content: stretch;
}

.navi-anchor {
  padding: 0 10px;
  height: 100%;
  box-sizing: border-box;
  display: inline-block;
}

.navi-anchor {
  display: flex;
  align-items: center;
  color: #212121;
  font-size: .95rem;

  &:link,
  &:visited,
  &:hover {
    text-decoration: none;
  }

  &:hover {
    color: #414141;
    // background: #f1f1f1;
  }
}

.navi-anchor.active {
  color: var(--zcar-primary);
  font-weight: bold;
  border-bottom: 2px solid var(--zcar-primary);
}

@media (min-width: 760px) {
  .navigation-wrapper {
    height: 56px;

    .navigation {
      max-width: 1280px;
      margin: 0 auto;
    }
   }

  .navi-anchor {
    padding: 0 20px;
    font-size: 1rem;
    white-space: nowrap;
  }

  .navi-anchors-wrapper {
    margin-left: auto;
    width: auto;
  }
 }

</style>
